import state from './moduleVesselNoonReportDetailState.js'
import mutations from './moduleVesselNoonReportDetailMutations.js'
import actions from './moduleVesselNoonReportDetailActions.js'
import getters from './moduleVesselNoonReportDetailGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
